import { render, staticRenderFns } from "./ExportSvg.vue?vue&type=template&id=40def8bd&"
import script from "./ExportSvg.vue?vue&type=script&lang=ts&"
export * from "./ExportSvg.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports